// Enum→Anzeige-Texte für frontend/src/ui/labels.ts.
//
// Hier steht NUR der Text. Die Badge-FARBE (`BadgeStatus`) bleibt in labels.ts:
// sie ist eine Eigenschaft des Zustands und keine der Sprache — sonst müsste
// jede Übersetzung die Farbe mitpflegen und könnte sie auseinanderlaufen lassen.
//
// Diese Datei ist ab dem Aufgaben-Umbau die EINZIGE Quelle der Zustands-Texte:
// `ui/labels.ts` hält nur noch die Farb-Zuordnung und liest den Text hier. Die
// Schlüssel der Farb-Map sind an `status` bzw. `statusDomain` getypt — ein
// Zustand, der hier fehlt (oder dort), ist ein Compiler-Fehler und keine
// stille Lücke.
export const labels = {
  status: {
    // ---- Aufgaben / Kanban / Zeitachse ----
    todo: "Zu erledigen",
    open: "Offen",
    new: "Neu",
    in_progress: "In Arbeit",
    ongoing: "Läuft",
    "on hold": "Pausiert",
    on_hold: "Pausiert",
    feedback: "Feedback",
    done: "Erledigt",
    closed: "Abgeschlossen",
    lost: "Verloren",

    // ---- Claims ----
    pending: "Ausstehend",
    approved: "Freigegeben",
    rejected: "Abgelehnt",

    // ---- Tabellen ----
    draft: "Entwurf",
    queued: "In Warteschlange",
    extracting: "Extrahiert …",
    ready: "Bereit",
    error: "Fehler",
    failed: "Fehlgeschlagen",

    // ---- Dokumente (Embedding + Zusammenfassung) ----
    doc_ai_pending: "Wartet auf Doc-AI",
    processing: "Verarbeitung …",

    // ---- Blog-Pipeline ----
    researching: "Recherche …",
    toc_building: "Gliederung …",
    toc_approved: "Gliederung freigegeben",
    skeleton_building: "Struktur …",
    generating: "Wird erzeugt …",
    generated: "Erzeugt",
    compliance_blocked: "Compliance geblockt",
    reviewer_blocked: "Prüfung nötig",
    needs_human_review: "Manuelle Prüfung",
    publishing: "Wird veröffentlicht …",
    published: "Veröffentlicht",
    archived: "Archiviert",

    // ---- Präsentationen ----
    planning: "Planung …",
    planned: "Geplant",
    rendered: "Gerendert",

    // ---- HeyGen (Skript + Video) ----
    claim_picking: "Claim-Auswahl …",
    scene_building: "Szenen …",
    exported: "Exportiert",
    completed: "Fertig",

    // ---- Generische Zustände ----
    running: "Läuft",
    active: "Aktiv",
    success: "Erfolgreich",
    ok: "OK",
    cancelled: "Abgebrochen",
    canceled: "Abgebrochen",
  },

  /** Kontext-spezifische Abweichungen: bei Dokumenten heißt der
   *  Abschluss-Zustand „Verarbeitet" und nicht „Erledigt" wie bei Aufgaben. */
  statusDomain: {
    document: {
      done: "Verarbeitet",
      completed: "Verarbeitet",
      pending: "Ausstehend",
    },
  },

  /** Analyse-Stufen (nie Modell-IDs in der Oberfläche zeigen). */
  level: {
    easy: "Schnell",
    medium: "Standard",
    hard: "Gründlich",
    sophisticated: "Experte",
  },

  /** Library-Klassifikation + Figur-Typen (Migrationen 0064/0065). */
  bildKlassifikation: {
    reuse_1to1: "Wiederverwendung 1:1",
    study_graphic: "Studien-Grafik",
    inspiration_editorial: "Inspiration (Editorial)",
    inspiration_infographic: "Inspiration (Infografik)",
    decorative_skipped: "Dekorativ (übersprungen)",
    unclassified: "Unklassifiziert",
    study_chart: "Studien-Diagramm",
    mechanism_diagram: "Mechanismus-Diagramm",
    photo: "Foto",
    decorative: "Dekorativ",
  },

  /** Rollen von Blog-Bild-Evidence-Blöcken. */
  bildRolle: {
    image_hero: "Hero-Bild",
    image_inline: "Inline-Bild",
    figure_embed: "Eingebettete Figur",
    linkedin_hero: "LinkedIn-Hero",
  },

  /** ANZEIGE-Name des system-seedeten Projekts. Der Name in der Datenbank
   *  bleibt „My SOPs" — er ist der Lookup-Schlüssel des per-User-SOP-Scopings
   *  (sync_users.py) und wird NUR beim Rendern ersetzt. In der englischen
   *  Oberfläche steht deshalb der Name selbst (ein Produktname wird nicht
   *  übersetzt), auf Deutsch der gewachsene Bestandstext. */
  projektMeineSops: "Meine SOPs",
};

export type LabelsKatalog = typeof labels;
